import React, { useContext, useState, useEffect } from "react";
import { motion } from "framer-motion";
import Experiments from "../components/Experiments/Experiments";
import Footer from "../components/Footer/Footer";
import OfficeTitle from "../components/Three/OfficeTitle";
import LoadingHome from "../components/Loading/LoadingHome";
import { Context } from "../context";

const ContactPage = () => {
  const { debug, lang } = useContext(Context);
  const [text, setText] = useState("");
  const [text2, setText2] = useState("");

  useEffect(() => {
    if (lang === "en") {
      setText("Experiments");
      setText2("Various experiments and media");
    } else if (lang === "it") {
      setText("Esperimenti");
      setText2("Vari esperimenti e media");
    }
  }, [lang]);

  return (
    <>
      <title>Davide Balice - Experiments</title>
      <LoadingHome />
      <motion.main
        initial={{ opacity: 0.6, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0.6 }}
        transition={{ duration: 0.4, delay: 1 }}
      >
        <OfficeTitle text={text} text2={text2} />
        <Experiments />
        <Footer />
      </motion.main>
    </>
  );
};

export default ContactPage;
